import CountryListPage from '../../src/pages/CountryListPage';

export default CountryListPage;
